import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import type { Task } from '../../store/types';
import { findSkillMentions, skillNames } from '../prompt-mention/reference-index';

const getMentionedSkills = (task: Task, skills: SkillFileNode[]) =>
  findSkillMentions([task.prompt, ...task.fields.map(field => field.prompt)].join('\n'), skillNames(skills));

export default getMentionedSkills;
